import LegalLayout, { LegalSection } from "../components/legal/LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy" updated="JUNE 2026" testId="privacy-page">
      <LegalSection n="01" title="Who We Are">
        <p>
          This Privacy Policy describes how Shoreline Mortgage Group ("we," "us," or "our") collects, uses, and
          protects personal information submitted through this website, including the VA Better-Buy Masterclass™
          registration and replay pages. By using this website or submitting a form, you agree to the practices
          described in this policy.
        </p>
      </LegalSection>

      <LegalSection n="02" title="Information We Collect">
        <p>When you register for the masterclass or request a Better Deal Review™, we collect:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Contact information: first name, last name, email address, and mobile phone number</li>
          <li>State of residence (Florida or Pennsylvania) and your self-described home-search stage or buyer situation</li>
          <li>Your consent selections and the date and time consent was given</li>
          <li>Technical and attribution data: page URL, referring URL, campaign parameters (such as UTM tags), and timestamps</li>
        </ul>
      </LegalSection>

      <LegalSection n="03" title="How We Use Your Information">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>To confirm your registration and send the webinar join link and reminders</li>
          <li>To respond to your request for a one-on-one Better Deal Review™</li>
          <li>To contact you by phone call, text message (SMS), and email as described in the consent you provide</li>
          <li>To operate, measure, and improve this website and our educational events</li>
          <li>To comply with legal, regulatory, and record-keeping obligations</li>
        </ul>
      </LegalSection>

      <LegalSection n="04" title="SMS / Text Messaging Privacy (A2P 10DLC)">
        <p className="font-semibold text-white/80">
          No mobile information will be shared with third parties or affiliates for marketing or promotional
          purposes.
        </p>
        <p>
          All categories of personal information described in this policy exclude text messaging originator opt-in
          data and consent; this information will not be shared with, or sold to, any third parties under any
          circumstances.
        </p>
        <p>
          Text messaging opt-in data and consent are used solely to deliver the messages you agreed to receive from
          Shoreline Mortgage Group, such as registration confirmations, event reminders, and follow-up related to
          your request. You may opt out of text messages at any time by replying STOP. For assistance, reply HELP.
        </p>
      </LegalSection>

      <LegalSection n="05" title="How We Share Information">
        <p>
          We do not sell your personal information. We share information only with service providers who help us
          operate this website and our communications (for example, our customer relationship management and
          messaging platform), and only as needed to provide those services. These providers are required to
          protect your information and may not use it for their own marketing. We may also disclose information
          when required by law, regulation, subpoena, or to protect our legal rights.
        </p>
      </LegalSection>

      <LegalSection n="06" title="Data Security & Retention">
        <p>
          We use commercially reasonable administrative, technical, and physical safeguards to protect your
          information. We retain personal information for as long as necessary to fulfill the purposes described in
          this policy and to meet legal and regulatory record-keeping requirements applicable to mortgage
          professionals.
        </p>
      </LegalSection>

      <LegalSection n="07" title="Your Choices & Rights">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Text messages: reply STOP to any message to opt out; reply HELP for help</li>
          <li>Emails: use the unsubscribe link in any marketing email</li>
          <li>Phone calls: ask to be placed on our internal do-not-call list</li>
          <li>You may request access to, correction of, or deletion of your personal information by contacting us using the details at the bottom of this page, subject to legal retention requirements</li>
        </ul>
      </LegalSection>

      <LegalSection n="08" title="Children's Privacy">
        <p>
          This website is intended for adults and is not directed to children under 18. We do not knowingly collect
          personal information from children.
        </p>
      </LegalSection>

      <LegalSection n="09" title="Changes to This Policy">
        <p>
          We may update this Privacy Policy from time to time. The "Last Updated" date at the top of this page
          reflects the most recent revision. Continued use of the website after changes are posted constitutes
          acceptance of the updated policy.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
